import { AuthStoreGetters } from "@/constants/store/auth/authStoreConstants";
import { AuthState, User } from "@/typings/store/states/AuthStoreState";

export default {
  [AuthStoreGetters.GET_USER]: (state: AuthState): User | null => state.user,
  [AuthStoreGetters.GET_ACCESS]: (state: AuthState) => state.access,
  [AuthStoreGetters.IS_AUTHORIZED]: (state: AuthState) => state.isAuthenticated,
  [AuthStoreGetters.GET_AUTH]: (state: AuthState) => state,
}